import React from 'react';

const SravanamasamOffer = () => {
  const styles = {
    container: {
      backgroundColor: '#faf1d9',
      color: '#d20b0b',
      //   border: '2px solid #8b0000',
      //   borderRadius: '10px',
      //   padding: '1rem',
      maxWidth: '600px',
      //   margin: '2rem auto',
      textAlign: 'center',
      fontFamily: "'Teachers', serif"
      //   boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)'
    },
    headingoffer: {
      fontSize: '1.2rem',
      marginBottom: '0rem',
      fontWeight: 'bold'
    },
    // date: {
    //   fontSize: '1.2rem',
    //   fontWeight: 'bold',
    //   color: '#b22222'
    // },
    text: {
      fontSize: '1rem',
      margin: '0.5rem 0'
    },
    text1: {
      fontSize: '12px',
      margin: '0.5rem 0'
    },
    cta: {
      marginTop: '1.5rem',
      backgroundColor: '#8b0000',
      color: '#fff',
      padding: '0.8rem 1.5rem',
      border: 'none',
      borderRadius: '5px',
      fontSize: '1rem',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    },
    ctaHover: {
      backgroundColor: '#a52a2a'
    },
    icon: {
      fontSize: '1.5rem',
      marginRight: '0.5rem'
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.headingoffer}>
        {/* <span role="img" aria-label="flower" style={styles.icon}>
          🌸
        </span> */}
        ✨ Pre-launch Special Offer! ✨
      </div>
      <p style={styles.text1}>
        Enjoy <strong>FREE subscription</strong> — limited-time offer
      </p>
      {/* <p style={styles.text}> valid until</p> */}
      <p style={styles.text1}>
        {/* valid until <strong> 25th August 2025 </strong> */}
      </p>
      <p style={styles.text1}>Start your journey today.</p>
      {/* <p style={styles.text}>
        <em> Uniting Hearts. Honoring Traditions.</em>
      </p> */}
      {/* <button
        style={styles.cta}
        onMouseOver={(e) => (e.target.style.backgroundColor = '#a52a2a')}
        onMouseOut={(e) => (e.target.style.backgroundColor = '#8b0000')}
      >
        Register Now
      </button> */}
    </div>
  );
};

export default SravanamasamOffer;
